// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3vQnp","active":"downloadDropdown_active__2L3GW"};